import { graphql } from ':src/graphql';

export const organizationSetupChecklistQuery = graphql(`
  query OrganizationSetupChecklistQuery {
    viewer {
      id
      organization {
        id
        isOnboarding
        setupChecklist {
          id
          superviseesAddedAt
          emergencyContactAddedAt
          preferencesConfirmedAt
        }
      }
    }
  }
`);

export const organizationSessionActivitySummaryQuery = graphql(`
  query OrganizationSessionActivitySummary($organizationId: Int!, $programId: String) {
    organizationSessionActivitySummary(organizationId: $organizationId, programId: $programId) {
      clinicalSkillsActivity {
        clinicalSkill {
          id
          name
        }
        sessionCount
      }
      professionalDevelopmentToolsActivity {
        professionalDevelopmentTool {
          id
          name
        }
        sessionCount
      }
    }
  }
`);

export const organizationRecentActivityQuery = graphql(`
  query OrganizationRecentActivity($organizationId: Int!, $programId: String, $limit: Int) {
    organizationRecentActivity(
      organizationId: $organizationId
      programId: $programId
      limit: $limit
    ) {
      eventType
      timestamp
      supervisee {
        id
        fullName
        organizationUser(deletedForOrganizationId: $organizationId) {
          id
          deletedAt
        }
      }
      supervisor {
        id
        slug
        fullName
        hasActiveOrganizationMatch(organizationId: $organizationId)
      }
    }
  }
`);
